import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import styled from 'styled-components';

const StyledClatterAIButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 9px;
  border-radius: ${({ theme }) => theme.radius.large};
  border: 1px solid ${({ theme }) => theme?.palette?.border || '#e0e0e0'};
  background: #fff;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #7c3aed;
    color: #fff;
    flex-shrink: 0;

    svg {
      font-size: 20px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;

    .title-row {
      display: flex;
      align-items: center;
      gap: 8px;

      .title {
        font-size: ${({ theme }) => theme.fontSize.default};
        font-weight: 600;
        color: #1a1a1a;
        white-space: nowrap;
      }

      .badge {
        font-size: 10px;
        font-weight: 600;
        color: #7c3aed;
        background: #ede9fe;
        padding: 2px 8px;
        border-radius: 4px;
        white-space: nowrap;
      }
    }

    .subtitle {
      font-size: ${({ theme }) => theme.fontSize.xsmall};
      color: ${({ theme }) => theme.palette.grayLighter};
    }
  }
`;

interface Props {
  disabled?: boolean;
  testId?: string;
  title?: string;
  subtitle?: string;
  isBeta?: boolean;
  onClick: () => void;
}

export const NgAIAssistantButton: FC<Props> = ({
  onClick,
  title = 'New Presentation',
  subtitle = 'Clatter AI Assistant',
  isBeta = true,
  disabled = false,
  testId = 'AIAssistantButton',
}) => {
  return (
    <StyledClatterAIButton type="button" onClick={onClick} data-testid={testId}>
      <span className="icon">
        <AutoAwesomeIcon />
      </span>
      <span className="content">
        <span className="title-row">
          <span className="title">{title}</span>
          {isBeta && <span className="badge">Beta</span>}
        </span>
        <span className="subtitle">{subtitle}</span>
      </span>
    </StyledClatterAIButton>
  );
};
